import { Pipe, PipeTransform } from '@angular/core'
@Pipe({
  name: 'Events',
})
export class EventsPipe implements PipeTransform {
  transform(items: any[], searchString: any, currentPage: number, itemsPage: number,
    dateModelSearch: any): any[] {
    if (!items) {
      return []
    }
    if (!searchString || searchString === '' || !dateModelSearch) {
      return items
    }
    return items.filter(item => {
      const tabs = item.campus.toString()

      return tabs.toLowerCase().includes(searchString.label.toLowerCase()) && item.date.start >= dateModelSearch.start
        && item.date.start <= dateModelSearch.end
    }).slice(8 * (currentPage - 1), itemsPage * (currentPage))
  }
}
